export const sanitizeUnitValues = (values) => {
  const sanitized = { ...values };
  for (const key in sanitized) {
    if (sanitized[key] === "") {
      sanitized[key] = null;
    }
  }
  if (sanitized.active === "" || sanitized.active === null) {
    sanitized.active = true;
  }
  return sanitized;
};

export const toUnitPayload = (sanitized) => ({
  block: sanitized.block,
  client: sanitized.client,
  contract: sanitized.contract,
  unit_type: sanitized.unit_type,
  settlement_price: sanitized.settlement_price,
  nr: sanitized.nr,
  initial_price: sanitized.initial_price,
  settled_price: sanitized.settled_price,
  cf: sanitized.cf,
  floor: sanitized.floor,
  num_rooms: sanitized.num_rooms,
  net_sqm: sanitized.net_sqm,
  gross_sqm: sanitized.gross_sqm,
  apt_net_sqm: sanitized.apt_net_sqm,
  terrace_net_sqm: sanitized.terrace_net_sqm,
  apt_type: sanitized.apt_type,
});
